import { createActionCreator, paramsEncode } from '../../../utils/';
import request from '../../../utils/request';
import constant, { encode } from './constant';
import Urls from '../../../../config/index';
import { message } from 'antd';

export const createLoadingAction = createActionCreator(constant.loading, loading => loading);
export const createUserGroupsAction = createActionCreator(constant.userGroups, list => list);
export const createSearchAction = createActionCreator(constant.search, o => o);
export const createUserGroupAction = createActionCreator(constant.userGroup, o => o);
export const createUsersAction = createActionCreator(constant.users, list => list);
export const createModalAction = createActionCreator(constant.modal, o => o);

let userGroupUrls = Urls.UserUrl;

//获取操作日志
export const getUserGroups = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let search = getState().userGroup.search;
            let response = await request(userGroupUrls.getUserGroups, 'post', search);
            dispatch(createSearchAction({ total: response.total }));
            dispatch(createUserGroupsAction(response.list));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    }
}

export const onFieldsChange = (search) => {
    return (dispatch, getState) => {
        dispatch(createSearchAction(search));
    }
}

export const modalStatus = (modal) => {
    return (dispatch, getState) => {
        dispatch(createModalAction(modal));
    }
}

//改变用户组对象用于添加或者修改
export const changeUserGroup = (userGroup) => {
    return (dispatch, getState) => {
        dispatch(createUserGroupAction(userGroup));
    }
}
//获取用户列表
export const getUsers = () => {
    return async (dispatch, getState) => {
        try {
            let search = { page: 1, pageSize: 10000 };//默认这个地方查全部，用户暂时不会大于10000
            let response = await request(userGroupUrls.list + paramsEncode(search).replace(/\&/, '?'));
            dispatch(createUsersAction(response.list));
        } catch (e) {
            throw new Error(e);
        }
    }
}

//添加用户组
export const addUserGroup = () => {
    return async (dispatch, getState) => {
        try {
            let usergroup = getState().userGroup.userGroupData;
            let response = await request(userGroupUrls.addUserGroups, 'post', Object.assign({}, usergroup));
            dispatch(createModalAction({ visible: false }));
        } catch (e) {
            throw new Error(e);
        }
    }
}

//修改用户组
export const editUserGroup = () => {
    return async (dispatch, getState) => {
        try {
            let usergroup = getState().userGroup.userGroupData;
            let response = await request(userGroupUrls.editUserGroups, 'post', encode(usergroup));
            dispatch(createModalAction({ visible: false }));
        } catch (e) {
            throw new Error(e);
        }
    }
}

//删除用户组
export const delUserGroup = (record) => {
    return async (dispatch, getState) => {
        try {
            let response = await request(userGroupUrls.delUserGroups, 'delete', record);
            message.success('删除成功')
        } catch (e) {
            message.error(e);
            throw new Error(e);
        }
    }
}


// WEBPACK FOOTER //
// ./pages/user/userGroup/actions.js